import { Component } from "@angular/core";
import { ConfigService } from "@core/data/config.service";

@Component({
    selector: "app-unauthorized",
    templateUrl: "./unauthorized.component.html",
    standalone: false,
})
export class UnauthorizedComponent {
    public loginLink: string;

    constructor(private conf: ConfigService) {
        this.conf.populate().subscribe(() => {
            const base = this.conf.getMemberPortalUrlConfig();
            this.loginLink = `${base}/login`;
            window.location.href = `${base}/sessionExpired`;
        });
    }
}
